import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "name" }
const _hoisted_2 = { class: "type" }
const _hoisted_3 = { class: "kind" }
const _hoisted_4 = { class: "rarity" }
const _hoisted_5 = { class: "main" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "type" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_10 = { class: "monetary" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "光尘货币", -1)
const _hoisted_14 = { class: "info" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "money" }
const _hoisted_17 = { class: "sell" }
const _hoisted_18 = { class: "shop-list" }
const _hoisted_19 = { class: "shop-top" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h1", { class: "shop-title" }, "随机商店", -1)
const _hoisted_21 = { class: "shop-options" }
const _hoisted_22 = { id: "refresh-count" }
const _hoisted_23 = { id: "pay-count" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", { class: "shop-line" }, null, -1)
const _hoisted_25 = { class: "fixed-list" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", { class: "shop-title" }, "固定售卖", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("hr", { class: "shop-line" }, null, -1)
const _hoisted_28 = { class: "item-list" }
const _hoisted_29 = ["onMousemove", "onClick"]
const _hoisted_30 = { class: "random-list" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h2", { class: "shop-title" }, "随机售卖", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", { class: "shop-line" }, null, -1)
const _hoisted_33 = { class: "item-list" }
const _hoisted_34 = ["onMousemove", "onClick"]
const _hoisted_35 = { class: "backpack" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "backpack-top" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "backpack-title" }, "背包"),
  /*#__PURE__*/_createElementVNode("hr", { class: "backpack-line" })
], -1)
const _hoisted_37 = { class: "item-list" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "选择要删除的卡牌", -1)
const _hoisted_39 = { class: "card-list-box" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "card" }
const _hoisted_42 = { class: "card-info" }
const _hoisted_43 = { class: "card-id" }
const _hoisted_44 = { class: "card-name" }
const _hoisted_45 = { class: "card-confirm-box" }
const _hoisted_46 = {
  key: 0,
  class: "shop-closed"
}

import {playerMoney} from "@/assets/ts/utils";
import {
  fixedItems,
  randomItems,
  backpackItems,
  backpackImg,
  refreshMoney,
  refreshCount,
  shopClosed,
  waterDialogVisible,
  fixedImg,
  tooltipShow,
  tooltipLocation,
  itemName,
  itemKind,
  itemRarity,
  itemDescription,
  sellMoney,
  wrapper,
  header,
  moveTooltip,
  showTooltip,
  hideTooltip,
  buyItem,
  waterDeckList,
  deleteCardItem,
  refreshShop,
  randomItemsImg,
  openShop,
  initShop
} from "@/assets/ts/shop";

// 初始化

export default /*#__PURE__*/_defineComponent({
  __name: 'ShopView',
  setup(__props) {

initShop();


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    id: "shop",
    onMousemove: _cache[6] || (_cache[6] = ($event: any) => (_unref(moveTooltip)($event)))
  }, [
    _createElementVNode("div", {
      id: "tooltip",
      class: _normalizeClass({'show': _unref(tooltipShow)}),
      style: _normalizeStyle({transform: _unref(tooltipLocation)})
    }, [
      _createElementVNode("div", {
        class: "wrapper",
        style: _normalizeStyle({'background-color': _unref(wrapper)})
      }, [
        _createElementVNode("div", {
          class: "header",
          style: _normalizeStyle({'background-color': _unref(header)})
        }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(itemName)), 1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(itemKind)), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(itemRarity)), 1)
          ])
        ], 4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(itemDescription)), 1)
            ])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", {
                class: "light",
                src: require('@/assets/images/light.png'),
                alt: "light.png"
              }, null, 8, _hoisted_12),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(playerMoney)), 1),
                _createTextVNode(" / "),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(sellMoney)), 1)
              ])
            ])
          ])
        ])
      ], 4)
    ], 6),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            class: "button refresh-button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(refreshShop) && _unref(refreshShop)(...args)))
          }, "刷新商店"),
          _createElementVNode("p", _hoisted_22, "免费刷新次数：" + _toDisplayString(_unref(refreshCount)), 1),
          _createElementVNode("p", _hoisted_23, "付费刷新费用：" + _toDisplayString(_unref(refreshMoney)), 1)
        ]),
        _hoisted_24
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fixedItems), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item,
              class: "item",
              onMousemove: ($event: any) => (_unref(showTooltip)(item)),
              onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_unref(hideTooltip)())),
              onClick: ($event: any) => (_unref(buyItem)(item)),
              style: _normalizeStyle({ 'background-image': `url(${_unref(fixedImg)[index]})`})
            }, null, 44, _hoisted_29))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _hoisted_32,
        _createElementVNode("div", _hoisted_33, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(randomItems), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "item",
              onMousemove: ($event: any) => (_unref(showTooltip)(item)),
              onMouseout: _cache[2] || (_cache[2] = ($event: any) => (_unref(hideTooltip)())),
              onClick: ($event: any) => (_unref(buyItem)(item,index)),
              style: _normalizeStyle({'background-image': `url(${_unref(randomItemsImg)[index]})`})
            }, null, 44, _hoisted_34))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _hoisted_36,
      _createElementVNode("div", _hoisted_37, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(backpackItems), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "item",
            style: _normalizeStyle({'background-image': `url(${_unref(backpackImg)[index]})`})
          }, null, 4))
        }), 128))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      class: "card-dialog",
      modelValue: _unref(waterDialogVisible),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(waterDialogVisible) ? (waterDialogVisible).value = $event : null)),
      "close-on-click-modal": false,
      width: "79.25rem",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _hoisted_38,
        _createElementVNode("div", _hoisted_39, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(waterDeckList), (card, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card-item",
              key: index,
              onClick: ($event: any) => (_unref(deleteCardItem)(card, index))
            }, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("p", _hoisted_43, _toDisplayString(card.cardName), 1),
                  _createElementVNode("p", _hoisted_44, _toDisplayString(card.name), 1)
                ])
              ])
            ], 8, _hoisted_40))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("button", {
            type: "button",
            class: "button card-cancel",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (waterDialogVisible.value = false))
          }, "取消 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(shopClosed))
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("button", {
            class: "button open-shop",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(openShop) && _unref(openShop)(...args)))
          }, "开启商店")
        ]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})